export default __webpack_public_path__ + "static/media/calmFloat.c406606d.png";